// services/apiDeviceTokens.js
import axios from "../utils/axios";

/**
 * إرسال FCM token للـ Backend
 * @param {Object} data - { fcm_token, device_type }
 * @returns {Promise}
 */
export const sendDeviceToken = async (data) => {
    try {
        const response = await axios.post('/user/device-tokens', {
            fcm_token: data.fcm_token,
            device_type: data.device_type
        });

        console.log('✅ Device token sent successfully:', response.data);
        return response.data;
    } catch (error) {
        console.error('🚨 Error sending device token:', error);
        throw error;
    }
};

/**
 * حذف FCM token من Backend
 * @param {string} fcm_token
 * @returns {Promise}
 */
export const removeDeviceToken = async (fcm_token) => {
    try {
        const response = await axios.delete('/user/device-tokens', {
            data: { fcm_token }
        });

        console.log('✅ Device token removed successfully:', response.data);
        return response.data;
    } catch (error) {
        console.error('🚨 Error removing device token:', error);
        throw error;
    }
};

/**
 * تحديث FCM token
 * @param {Object} data - { old_token, new_token, device_type }
 * @returns {Promise}
 */
export const updateDeviceToken = async (data) => {
    try {
        const response = await axios.put('/user/device-tokens', {
            old_token: data.old_token,
            new_token: data.new_token,
            device_type: data.device_type
        });

        console.log('✅ Device token updated successfully:', response.data);
        return response.data;
    } catch (error) {
        console.error('🚨 Error updating device token:', error);
        throw error;
    }
};
